/**
 * Resolves the effective form/survey builder background image URL for the current device.
 * On mobile: uses mobileBgImage if set; otherwise falls back to bgImage unless mobileBgImageDeleted
 * is true (user intentionally removed mobile background / declined desktop fallback).
 */
export function getEffectiveBackgroundImageUrlForDevice(
  formStyle:
    | {
        bgImage?: string;
        mobileBgImage?: string;
        mobileBgImageDeleted?: boolean;
      }
    | undefined,
  deviceMode: string | undefined
): string {
  const isMobile = deviceMode === "mobile";
  const bg = (formStyle?.bgImage || "").trim();
  const mobile = (formStyle?.mobileBgImage || "").trim();
  const mobileDeleted = Boolean(formStyle?.mobileBgImageDeleted);

  if (isMobile) {
    if (mobile) {
      return mobile;
    }
    if (mobileDeleted) {
      return "";
    }
    return bg;
  }

  return bg;
}
